/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {FC, useEffect, useState} from 'react'
import {PageTitle} from '../../../../_metronic/layout/core'
import {getFeatureAd, putFeatureAd} from '../api/feature-ad'
import {useParams} from 'react-router-dom'
import {useHistory} from 'react-router'
import {toast} from 'react-toastify'
import {FeatureAdModel} from '../interface/FeatureAd'
import GoBack from '../../../components/partials/GoBack'
import Button from '../../../components/common/Button'

export interface IPageParams {
  id: string
}
const URL = '/feature-ad'
const EditFeatureAd: FC = () => {
  const {id} = useParams<IPageParams>()
  const [featureAd, setFeatureAd] = useState<FeatureAdModel>()
  const [loading, setLoading] = useState(false)
  const history = useHistory()

  useEffect(() => {
    getFeatureAd(id).then(({data}) => {
      setFeatureAd(data.result)
    })
  }, [id])

  function handleChange(event: React.ChangeEvent<any>) {
    const target = event.target
    const value = target.type === 'checkbox' ? target.checked : target.value
    const name = target.name
    const result = {...featureAd, [name]: value} as FeatureAdModel
    setFeatureAd(result)
  }

  function handleSubmit(event: React.ChangeEvent<any>) {
    event.preventDefault()
    setLoading(true)
    putFeatureAd(id, featureAd as FeatureAdModel)
      .then((data) => {
        // history.push(`/feature-ad/view/${id}`)
        history.push(URL)
        toast.success('Success!')
      })
      .catch((error) => {
        console.log(error)
      })
      .finally(() => {
        setLoading(false)
      })
  }
  return (
    <>
      <PageTitle breadcrumbs={[]}>Edit FeatureAd</PageTitle>

      {featureAd && (
        <form onSubmit={handleSubmit}>
          <div className='card pt-4 mb-6 mb-xl-9'>
            {/*begin::Card body*/}
            <div className='card-body pt-0 pb-5'>
              {/*begin::Table*/}
              <table className='table align-middle table-row-dashed gy-5'>
                {/*begin::Table body*/}
                <tbody className='fs-6 fw-bold text-gray-600'>
                  <tr>
                    <td>FeatureAd Name</td>
                    <td>
                      <input
                        type='text'
                        className='form-control'
                        value={featureAd.name}
                        onChange={handleChange}
                        name='name'
                        required
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>FeatureAd Offer</td>
                    <td>
                      <input
                        type='text'
                        className='form-control'
                        value={featureAd.offer}
                        onChange={handleChange}
                        name='offer'
                        required
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>FeatureAd Callback</td>
                    <td>
                      <input
                        type='text'
                        className='form-control'
                        value={featureAd.callback}
                        onChange={handleChange}
                        name='callback'
                        required
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>FeatureAd Callback Name</td>
                    <td>
                      <input
                        type='text'
                        className='form-control'
                        value={featureAd.callback_name}
                        onChange={handleChange}
                        name='callback_name'
                        required
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>Color</td>
                    <td>
                      <select
                        className='form-select'
                        data-kt-select2='true'
                        data-placeholder='Select option'
                        data-allow-clear='true'
                        name='color'
                        defaultValue={featureAd.color}
                        onChange={handleChange}
                        required
                      >
                        <option value='primary'>Primary</option>
                        <option value='warning'>Warning</option>
                        <option value='danger'>Danger</option>
                      </select>
                    </td>
                  </tr>
                  <tr>
                    <td>FeatureAd Image</td>
                    <td>
                      <img src={featureAd.image} alt='featureAd' height='50px' width='50px' />
                      <input
                        type='file'
                        name='image'
                        accept='.png, .jpg, .jpeg'
                        onChange={async (event: React.ChangeEvent<any>) => {
                          let formdata = new FormData()
                          formdata.append('file', event.currentTarget.files[0])
                          try {
                            const url: string = process.env.REACT_APP_IMAGE_UPLOAD as string
                            const res = await fetch(url, {
                              method: 'post',
                              body: formdata,
                            })
                            const data = await res.json()
                            if (data.status_code === 201) {
                              setFeatureAd({...featureAd, image: data['url']})
                            }
                          } catch (err) {
                            console.log(err)
                          }
                        }}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>Featured</td>
                    <td>
                      <input
                        type='checkbox'
                        id='flexCheckChecked'
                        className='form-check-input'
                        onChange={handleChange}
                        name='is_featured'
                        checked={featureAd.is_featured}
                      />
                    </td>
                  </tr>
                </tbody>
                {/*end::Table body*/}
              </table>
              {/*end::Table*/}
              <div className='d-flex justify-content-end align-items-center mt-15'>
                {/*begin::Button*/}
                <GoBack url={URL} />
                {/*end::Button*/}
                <Button loading={loading} name={'Update'} />
                {/* <input type='submit' value='Save' className='btn btn-primary' /> */}
                {/*begin::Button*/}
                {/* <button type='button' className='btn btn-primary' onClick={handleSubmit}>
                  <span className='indicator-label'>Save</span>
                  <span className='indicator-progress'>
                    Please wait...
                    <span className='spinner-border spinner-border-sm align-middle ms-2' />
                  </span>
                </button> */}
                {/*end::Button*/}
              </div>
            </div>
            {/*end::Card body*/}
          </div>
        </form>
      )}
    </>
  )
}

export default EditFeatureAd
